module.exports = __webpack_public_path__ + "static/media/eye-accesing-assessment.301bbaee.png";